import React from 'react';
import { ReactComponent as ArrowGoBackBlack } from 'images/new-icons/arrow-go-back.svg';
import './BackHeader.css';
import { useTranslation } from 'react-i18next';

interface BackHeaderProps {
  title: string;
  onBack: () => void;
}

const BackHeader: React.FC<BackHeaderProps> = ({ title, onBack }) => {
  const {t} = useTranslation() as any;
  return (
    <div className="back-header">
      <button className="back-button" onClick={onBack}>
        <ArrowGoBackBlack className="back-icon" />
      </button>
      <h2 className="back-header-title">{t(title)}</h2>
    </div>
  );
};

export default BackHeader;
